// extracted by mini-css-extract-plugin
module.exports = {"label":"text_label__6rEjy font-bold inline-block mr-2","content":"text_content__DEDsE inline-block","contentHtml":"text_contentHtml___ZuH_ inline-block"};